import type { ReactElement } from 'react';
import type { Button } from '../button/button.types';
import type { InputHtmlProps, ObjectValues } from '../types';
import type { Messages } from '../use-input-validation.types';

export const themes = {
  floating: 'floating',
  inline: 'inline',
} as const;

export const inputSizes = {
  small: 'small',
  large: 'large',
} as const;

export const variants = {
  default: 'default',
  fixed: 'fixed',
} as const;

export const expandDirections = {
  left: 'left',
  right: 'right',
} as const;

export type Search = {
  button?: Button;
  clear: Button;
  customErrorMessages?: Messages;
  expandable?: {
    close: Button;
    direction?: ObjectValues<typeof expandDirections>;
  };
  helpIcon?: ReactElement;
  helpText?: string;
  inputSize?: ObjectValues<typeof inputSizes>; //NOTE: This is not named `size` due to InputHTMLProps having a `size` attribute that will clash
  isLabelVisible?: boolean;
  label: string;
  name: string;
  onChangeFunc?: (arg: string) => void;
  onClear?: () => void;
  theme?: ObjectValues<typeof themes>;
  variant?: ObjectValues<typeof variants>;
} & InputHtmlProps;
